import React, { FC } from 'react';

import { Image } from '../Image/Image';
import { RichText } from '../RichText/RichText';
import { Text } from '../Text/Text';

import * as styles from './ListOfSetsOfImagesWithText.module.scss';

import { ListOfSetsOfImagesWithTextProps } from './ListOfSetsOfImagesWithText.types';

export const ListOfSetsOfImagesWithText: FC<ListOfSetsOfImagesWithTextProps> = ({ title, itemPerRow, items }) => {
    return (
        <>
            {title && (
                <div className={styles.title}>
                    <Text weight="medium" variant="sectionTitle" tag="h3" noMargin={true}>
                        <RichText textSize="sectionTitle" isTitle={true} content={title} />
                    </Text>
                </div>
            )}

            <ul className={styles[`container${itemPerRow}`]}>
                {items?.map((el, i) => {
                    return (
                        <li key={i}>
                            <div className={styles.containerImageText}>
                                <Image classWrapper={styles.imageWrapper} classImg={styles.image} image={el.image} />
                                {el.title ? (
                                    <span className={styles.text}>{el.title}</span>
                                ) : el.description ? (
                                    <RichText content={el.description} textSize="text1" />
                                ) : undefined}
                            </div>
                        </li>
                    );
                })}
            </ul>
        </>
    );
};
